var map = {
	"./Infinity-1.7s-94px.gif": 10143,
	"./Shot.png": 19671,
	"./audition_play.gif": 75893,
	"./background.png": 7057,
	"./bar_edit@2x.png": 3910,
	"./bar_generate@2x.png": 91069,
	"./bar_interaction@2x.png": 61879,
	"./base_of_nose@2x.png": 43595,
	"./beard_nor@2x.png": 24208,
	"./beard_sel@2x.png": 98661,
	"./beardcolor_nor@2x.png": 55326,
	"./beardcolor_sel@2x.png": 63502,
	"./beautiful_pupil_nor@2x.png": 79184,
	"./beautiful_pupil_sel@2x.png": 21265,
	"./boots_nor@2x.png": 98898,
	"./boots_sel@2x.png": 17704,
	"./bracelet_nor@2x.png": 64690,
	"./bracelet_sel@2x.png": 37528,
	"./btn_play@3x.png": 55294,
	"./clothes_nor@2x.png": 74541,
	"./clothes_sel@2x.png": 18101,
	"./coat_nor@2x.png": 81767,
	"./coat_sel@2x.png": 37210,
	"./completeset_nor@2x.png": 75575,
	"./completeset_sel@2x.png": 29502,
	"./corner_mouth@2x.png": 35544,
	"./corner_mouth_small@2x.png": 85177,
	"./drawer_bg2@2x.png": 96785,
	"./ear_nor@2x.png": 38416,
	"./ear_sel@2x.png": 41211,
	"./earrings_nor@2x.png": 87846,
	"./earrings_sel@2x.png": 85930,
	"./eye@2x.png": 89401,
	"./eye_inner@2x.png": 75953,
	"./eye_nor@2x.png": 18554,
	"./eye_outside@2x.png": 93453,
	"./eye_sel@2x.png": 38654,
	"./eyebrow@2x.png": 24816,
	"./eyebrow_inner@2x.png": 45769,
	"./eyebrow_mid@2x.png": 61548,
	"./eyebrow_nor@2x.png": 20295,
	"./eyebrow_outer@2x.png": 93481,
	"./eyebrow_sel@2x.png": 75486,
	"./eyebrowcolor_nor@2x.png": 39800,
	"./eyebrowcolor_sel@2x.png": 71860,
	"./eyecolor_nor@2x.png": 19369,
	"./eyecolor_sel@2x.png": 38359,
	"./eyelash_nor@2x.png": 50706,
	"./eyelash_sel@2x.png": 66625,
	"./eyelid_inner@2x.png": 12237,
	"./eyeshadow_nor@2x.png": 86543,
	"./eyeshadow_sel@2x.png": 41933,
	"./eyeshadowcolor_nor@2x.png": 28618,
	"./eyeshadowcolor_sel@2x.png": 64498,
	"./face_nor@2x.png": 8771,
	"./face_sel@2x.png": 47057,
	"./facepainting_nor@2x.png": 93033,
	"./facepainting_sel@2x.png": 83663,
	"./facial_decoration_sel@2x.png": 71278,
	"./female_cheek@2x.png": 16022,
	"./female_cheekbone@2x.png": 13884,
	"./female_chin@2x.png": 88557,
	"./female_chin_tip@2x.png": 64985,
	"./female_forehead@2x.png": 9106,
	"./female_lower_face@2x.png": 65577,
	"./female_mandible@2x.png": 76880,
	"./female_mandibular_angle@2x.png": 73902,
	"./female_masseter@2x.png": 35613,
	"./female_ophryon@2x.png": 82104,
	"./female_temple@2x.png": 11928,
	"./fu_eight_head_body.png": 73751,
	"./fu_five_head_body.png": 45069,
	"./fu_nine_head_body.png": 95484,
	"./fu_seven_head_body.png": 48221,
	"./fu_six_head_body.png": 59190,
	"./glasses_nor@2x.png": 13054,
	"./glasses_sel@2x.png": 48019,
	"./haircolor_nor@2x.png": 39127,
	"./haircolor_sel@2x.png": 73341,
	"./hairstyle_nor@2x.png": 98442,
	"./hairstyle_sel@2x.png": 94811,
	"./hat_nor@2x.png": 69796,
	"./hat_sel@2x.png": 40556,
	"./head_of_nose@2x.png": 24574,
	"./icon_camera_nor.png": 73492,
	"./icon_clear_nor.png": 56307,
	"./icon_clothing_collection_sel.svg": 14126,
	"./icon_drawer_audition.png": 70528,
	"./icon_drawer_audition@2x.png": 96721,
	"./icon_drawer_audition_active.png": 86111,
	"./icon_drawer_history.png": 45826,
	"./icon_drawer_history_active.png": 52515,
	"./icon_edit_back to homepage@2x.png": 24362,
	"./icon_female_nor.png": 17635,
	"./icon_female_sel.png": 42474,
	"./icon_forword_nor.png": 53616,
	"./icon_home_action_library.png": 64466,
	"./icon_home_avatar_camera.png": 18386,
	"./icon_home_avatar_female.png": 21238,
	"./icon_home_avatar_male.png": 51941,
	"./icon_home_cloth_material.png": 16638,
	"./icon_home_emoji_template.png": 49056,
	"./icon_home_picture_template.png": 66950,
	"./icon_home_tts_drive.png": 41613,
	"./icon_home_video_template.png": 38436,
	"./icon_homepage_gender_female@2x.png": 57097,
	"./icon_homepage_gender_male@2x.png": 48656,
	"./icon_homepage_image@2x.png": 73163,
	"./icon_homepage_saveimage@2x.png": 4132,
	"./icon_homepage_scan@2x.png": 8798,
	"./icon_interaction_function_nor@2x.png": 60332,
	"./icon_interaction_function_sel@2x.png": 61904,
	"./icon_interaction_history_nor@2x.png": 72652,
	"./icon_interaction_history_sel@2x.png": 85111,
	"./icon_loading.png": 98810,
	"./icon_logo_avatar.png": 13499,
	"./icon_logo_avatar1.png": 39533,
	"./icon_male_nor.png": 41394,
	"./icon_male_sel.png": 64494,
	"./icon_overall_empty@3x.png": 80251,
	"./icon_popup_abnormal@3x.png": 43368,
	"./icon_popup_cancel send@3x.png": 94143,
	"./icon_popup_voice@3x.png": 9778,
	"./icon_send_abled.svg": 28907,
	"./icon_send_active.png": 72786,
	"./icon_send_disable.png": 42733,
	"./icon_send_disable.svg": 387,
	"./icon_sidebar_accessories_nor@2x.png": 31952,
	"./icon_sidebar_accessories_sel@2x.png": 96333,
	"./icon_sidebar_clothes_nor@2x.png": 13439,
	"./icon_sidebar_clothes_sel@2x.png": 38529,
	"./icon_sidebar_face_nor@2x.png": 89812,
	"./icon_sidebar_face_sel@2x.png": 35556,
	"./icon_sidebar_shoes_nor@2x.png": 51803,
	"./icon_sidebar_shoes_sel@2x.png": 98825,
	"./icon_sidebar_trousers_nor@2x.png": 28852,
	"./icon_sidebar_trousers_sel@2x.png": 25764,
	"./icon_tab2_custom@2x.png": 1053,
	"./icon_tab2_download.png": 93590,
	"./icon_tab2_selected@2x.png": 48377,
	"./icon_talk_delete.svg": 57868,
	"./icon_talk_pause.svg": 17908,
	"./icon_talk_play.svg": 76790,
	"./icon_talk_voice.svg": 27633,
	"./icon_talk_voice_active.svg": 62517,
	"./icon_toast_loading.png": 16381,
	"./icon_turning.png": 91783,
	"./icon_voice_nor@3x.png": 673,
	"./icon_withdraw_nor.png": 85951,
	"./lipcolor_nor@2x.png": 43105,
	"./lipcolor_sel@2x.png": 38820,
	"./lipmakeup_nor@2x.png": 64990,
	"./lipmakeup_sel@2x.png": 84428,
	"./lips_nor@2x.png": 4010,
	"./lips_sel@2x.png": 32155,
	"./logo_avatar.png": 10190,
	"./logo_avatarX.png": 775,
	"./lower_eyelid_inner@2x.png": 13083,
	"./lower_eyelid_mid@2x.png": 22813,
	"./lower_eyelid_outside@2x.png": 9965,
	"./lower_lip@2x.png": 57693,
	"./male_cheek@2x.png": 48782,
	"./male_cheekbone@2x.png": 69919,
	"./male_chin@2x.png": 51640,
	"./male_chin_tip@2x.png": 25338,
	"./male_forehead@2x.png": 80517,
	"./male_lower_face@2x.png": 22710,
	"./male_mandible@2x.png": 82176,
	"./male_mandibular_angle@2x.png": 63974,
	"./male_masseter@2x.png": 97208,
	"./male_ophryon@2x.png": 85083,
	"./male_temple@2x.png": 58358,
	"./mentolabial_sulcus@2x.png": 63868,
	"./middle_lip_down@2x.png": 23870,
	"./middle_lip_up@2x.png": 43152,
	"./mouth@2x.png": 93510,
	"./necklace_nor@2x.png": 89871,
	"./necklace_sel@2x.png": 80449,
	"./nose@2x.png": 61989,
	"./nose_bridge@2x.png": 40442,
	"./nose_nor@2x.png": 45698,
	"./nose_root@2x.png": 75397,
	"./nose_sel@2x.png": 55515,
	"./nose_wing@2x.png": 62602,
	"./rouge_nor@2x.png": 48324,
	"./rougecolor_nor@2x.png": 28086,
	"./rougecolor_sel@2x.png": 74483,
	"./shoes_nor@2x.png": 40727,
	"./shoes_sel@2x.png": 38854,
	"./shorts_nor@2x.png": 96189,
	"./shorts_sel@2x.png": 29538,
	"./side_of_nose@2x.png": 33882,
	"./sidebar_body_nor@2x.png": 11767,
	"./sidebar_body_sel@2x.png": 5852,
	"./skin_nor@2x.png": 96173,
	"./skin_sel@2x.png": 67006,
	"./skirts_nor@2x.png": 55788,
	"./skirts_sel@2x.png": 6815,
	"./suit_nor@2x.png": 10822,
	"./suit_sel@2x.png": 91421,
	"./sweater_nor@2x.png": 64948,
	"./sweater_sel@2x.png": 79199,
	"./tab1_body_nor@2x.png": 66909,
	"./tab1_body_sel@2x.png": 95628,
	"./trousers_nor@2x.png": 84899,
	"./trousers_sel@2x.png": 91777,
	"./upper_eyelid_inner@2x.png": 81223,
	"./upper_eyelid_mid@2x.png": 6563,
	"./upper_eyelid_outside@2x.png": 58369,
	"./upper_lip@2x.png": 48264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98851;